
export default {
	props: ['error'],
	head: {
		title: 'Ошибка 404'
	}
}
